module.exports = __webpack_public_path__ + "img/alipay_success@3x.38dfa53a.png";